import React from 'react';
import BoardDetail from './BoardDetail';

export default function NoticeDetail() {
  return <BoardDetail fixedType="notice" basePath="/notice" />;
}
